export default __webpack_public_path__ + "static/media/prg.d28eef30.mp4";